// extracted by mini-css-extract-plugin
module.exports = {"procurement":"_1Fd1bzA5xn3Iyg8uLOxVeH","methods":"_3prADKtHRIJxQ_kAmfDBb-","cook":"_2i3wXbCuxIYDQEiQ2sTGH7","deliver":"K9k2VoZpzrfkgvr_SO2U2"};